import { useTheme } from "@/Layouts/ThemeContext";
import { Moon, Sun1 } from "iconsax-react";
import React from "react";

export default function ClockTheme() {
    const { theme, toggleTheme } = useTheme();

    return (
        <>
            {theme === "dark" ? (
                <Moon size="24" className="hover:!text-custom-dark-blue" />
            ) : (
                <Sun1 size="24" className="hover:text-custom-dark-blue" />
            )}
        </>
    );
}
